import type { ComponentProps } from "react";
import classNames from "classnames";
import { BOARD_DRAG_THROUGH_ATTRIBUTE } from "./boardSensors";
import styles from "./BoardCard.module.scss";

type BoardCardTitleButtonProps = Omit<
    ComponentProps<"button">,
    "type" | "tabIndex"
>;

const DRAG_THROUGH_PROPS = { [BOARD_DRAG_THROUGH_ATTRIBUTE]: "" };

/**
 * A card title that acts on click, such as a rename in place: a quiet
 * button hugging the text that shows a border on hover, hanging outside
 * the words so they don't move. Render it as `BoardCardTitle`'s only child;
 * it stays on one line like a plain title, and its cut-off text shows in the
 * title's tooltip. Pointer only, like the card's other controls: a
 * click is its own and doesn't open the card, while a press and move still
 * drags the card.
 */
export const BoardCardTitleButton = ({
    className,
    children,
    ...buttonProps
}: Readonly<BoardCardTitleButtonProps>) => (
    <button
        {...buttonProps}
        {...DRAG_THROUGH_PROPS}
        type="button"
        tabIndex={-1}
        className={classNames(styles.titleButton, className)}
    >
        <span className={styles.titleButtonText}>{children}</span>
    </button>
);
